var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 156,
    viewBox: "0 0 143 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 108.924L54.7994 155.016L1 79.0156L88 108.924Z",
    fill: "url(#paint0_linear_118_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 108.924L54.7994 155.016L1 79.0156L88 108.924Z",
    fill: "url(#paint1_linear_118_8)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.391 109.107L54.8861 155.458L0.59375 79.0293L88.391 109.107Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.391 109.107L54.8861 155.458L0.59375 79.0293L88.391 109.107Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0.015625L55.5089 98.0156L1 79.2062L56 0.015625Z",
    fill: "url(#paint2_linear_118_8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56 0.015625L55.5089 98.0156L1 79.2062L56 0.015625Z",
    fill: "url(#paint3_linear_118_8)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.884 0L55.3903 97.7996L0.597656 79.0287L55.884 0Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143 29.758L56 62.0156L56.3094 0.015625L143 29.758Z",
    fill: "url(#paint4_linear_118_8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143 29.758L56 62.0156L56.3094 0.015625L143 29.758Z",
    fill: "url(#paint5_linear_118_8)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.571 29.6932L55.5703 61.8975L55.8797 0L142.571 29.6932Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143 128.016L88 50.0823L143 30.0156V128.016Z",
    fill: "url(#paint6_linear_118_8)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143 128.016L88 50.0823L143 30.0156V128.016Z",
    fill: "url(#paint7_linear_118_8)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.573 127.665L88.3789 49.7541L142.573 29.6934V127.665Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55 155.016L109.659 80.0156L143 127.428L55 155.016Z",
    fill: "url(#paint8_linear_118_8)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55 155.016L109.659 80.0156L143 127.428L55 155.016Z",
    fill: "url(#paint9_linear_118_8)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8867 155.458L109.35 79.9004L142.572 127.665L54.8867 155.458Z",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2544 88.0156L56 0.015625L1 78.6741L28.2544 88.0156Z",
    fill: "url(#paint10_linear_118_8)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62.0156L143 30.0156L56.1448 33.1188L56 62.0156Z",
    fill: "url(#paint11_linear_118_8)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.521 39.0156L143 128.016L88 49.8196L117.521 39.0156Z",
    fill: "url(#paint12_linear_118_8)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.017 80.0156L55 155.016L124 101.57L109.017 80.0156Z",
    fill: "url(#paint13_linear_118_8)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1 79.0156L72.9286 130.016L88 108.973L1 79.0156Z",
    fill: "url(#paint14_linear_118_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_8",
    x1: 67.8376,
    y1: 177.709,
    x2: 25.0181,
    y2: 69.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_8",
    x1: 67.8376,
    y1: 177.709,
    x2: 25.0181,
    y2: 69.4002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_8",
    x1: 43.2537,
    y1: 127.278,
    x2: -35.6575,
    y2: 29.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_8",
    x1: 43.2537,
    y1: 127.278,
    x2: -35.6575,
    y2: 29.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_118_8",
    x1: 122.838,
    y1: 80.5289,
    x2: 92.9913,
    y2: -12.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_118_8",
    x1: 122.838,
    y1: 80.5289,
    x2: 92.9913,
    y2: -12.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_118_8",
    x1: 130.254,
    y1: 157.278,
    x2: 51.3425,
    y2: 59.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_118_8",
    x1: 130.254,
    y1: 157.278,
    x2: 51.3425,
    y2: 59.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_118_8",
    x1: 122.606,
    y1: 177.411,
    x2: 81.1096,
    y2: 69.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_118_8",
    x1: 122.606,
    y1: 177.411,
    x2: 81.1096,
    y2: 69.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_118_8",
    x1: 43.2537,
    y1: 114.292,
    x2: -25.6317,
    y2: 19.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_118_8",
    x1: 122.838,
    y1: 71.5708,
    x2: 114.297,
    y2: 20.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_118_8",
    x1: 130.254,
    y1: 154.591,
    x2: 60.3435,
    y2: 59.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_118_8",
    x1: 108.009,
    y1: 177.411,
    x2: 59.0583,
    y2: 77.9009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_118_8",
    x1: 67.8376,
    y1: 145.244,
    x2: 47.0078,
    y2: 66.7294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject5);
export default __webpack_public_path__ + "static/media/project5.22c6509e0758b0ea94e12f3700e9800d.svg";
export { ForwardRef as ReactComponent };